import { Switch, SwitchProps, styled } from '@mui/material';
import { color } from '@/colors';

export const AppSwitch = styled(Switch)<SwitchProps>(() => ({
  width: 32,
  height: 16,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 0,
    top: 0,
    left: 0,
    transitionDuration: '300ms',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:focus-visible': {
      outline: 'none',
    },
    '&.Mui-checked': {
      transform: 'translateX(18px)',
      color: color.Black92,
      '& + .MuiSwitch-track': {
        backgroundColor: color.White100,
        opacity: 1,
        border: 0,
      },
      '& .MuiSwitch-thumb': {
        width: 12,
        height: 12,
        backgroundColor: color.Black92,
        marginLeft: 0,
      },
    },
    '&.Mui-disabled': {
      '& .MuiSwitch-thumb': {
        backgroundColor: color.White16_T,
      },
      '& + .MuiSwitch-track': {
        backgroundColor: color.White04_T,
        opacity: 1,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 8,
    height: 8,
    backgroundColor: color.White40_T,
    transition: 'width 300ms, height 300ms, background-color 300ms, margin-top 300ms, margin-left 300ms',
    marginTop: 4, // Center 8px thumb in 16px track: (16-8)/2 = 4
    marginLeft: 4,
    boxShadow: 'none',
  },
  '& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb': {
    marginTop: 2, // Center 12px thumb in 16px track: (16-12)/2 = 2
  },
  '& .MuiSwitch-track': {
    borderRadius: 8,
    backgroundColor: color.White16_T,
    opacity: 1,
    transition: 'background-color 300ms',
    width: 32,
    height: 16,
  },
  '& .MuiTouchRipple-root': {
    display: 'none',
  },
}));
